import { render } from "./CustomerServiceButton.vue?vue&type=template&id=9b34da5c&scoped=true"
import script from "./CustomerServiceButton.vue?vue&type=script&lang=js"
export * from "./CustomerServiceButton.vue?vue&type=script&lang=js"

import "./CustomerServiceButton.vue?vue&type=style&index=0&id=9b34da5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b34da5c"]])

export default __exports__